<template>
  <div class="card border-0 shadow-sm">
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-center">
        <h5 class="text-black-50 mb-0">Transactions</h5>
        <div class="dropdown">
          <button
              class="btn p-0"
              type="button"
              id="transactionID"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
          >
            <i class="fa-solid fa-ellipsis-vertical"></i>
          </button>
          <div class="dropdown-menu dropdown-menu-end" aria-labelledby="transactionID">
            <a class="dropdown-item" href="javascript:void(0);">Last 28 Days</a>
            <a class="dropdown-item" href="javascript:void(0);">Last Month</a>
            <a class="dropdown-item" href="javascript:void(0);">Last Year</a>
          </div>
      </div>
      </div>
      <hr>
      <ul class="p-0 m-0">
        <li  v-for="p in products" class="d-flex mb-4 pb-1">
          <div class="me-3">
            <img :src="require('../assets/unicons/' + p.image)"
                 alt="User" class="rounded logo-img" />
          </div>
          <div class="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
            <div class="me-2">
              <small class="text-muted d-block mb-1">{{ p.bankName }}</small>
              <h6 class="mb-0">{{ p.type }}</h6>
            </div>
            <div class="user-progress d-flex align-items-center gap-1">
              <h6 class="mb-0">{{ p.amount }}</h6>
              <span class="text-muted">{{ p.currency }}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Transaction",
  data() {
    return {
      products: [
        {
          id:1,
          image:'paypal.png',
          bankName: 'Paypal',
          type : 'Send money',
          amount: '+82.6',
          currency: 'USD',
        },
        {
          id:2,
          image:'chart.png',
          bankName: 'Transfer',
          type : 'Refund',
          amount: '+637.91',
          currency: 'USD',
        },
        {
          id:3,
          image:'cc-success.png',
          bankName: 'Credit Card',
          type : 'Ordered Food',
          amount: '-838.71',
          currency: 'USD',
        },
        {
          id:4,
          image:'wallet.png',
          bankName: 'Wallet',
          type : 'Starbucks',
          amount: '+203.33',
          currency: 'USD',
        },
        {
          id:5,
          image:'cc-warning.png',
          bankName: 'Mastercard',
          type : 'Ordered Food',
          amount: '-92.45',
          currency: 'USD',
        },
      ],
    }
  },
}
</script>

<style scoped>
.logo-img{
  width: 50px;
  height: 50px;
}
</style>